import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="container mx-auto max-w-4xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-center">Privacy Policy</CardTitle>
            <p className="text-center text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
              <p>
                When you use our WhatsApp Business messaging service, we collect:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Contact information (phone numbers, names) you provide</li>
                <li>Message content and media you send and receive</li>
                <li>Business account information for WhatsApp Business API access</li>
                <li>Usage data and analytics for service improvement</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
              <p>We use collected information to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Provide WhatsApp messaging services</li>
                <li>Process and deliver your messages</li>
                <li>Manage your business communications</li>
                <li>Improve our service quality and features</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. WhatsApp Business API Integration</h2>
              <p>
                Our service integrates with WhatsApp Business API. By using our service:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Your messages are processed through Meta's WhatsApp Business platform</li>
                <li>Meta's privacy policies and terms also apply to your WhatsApp communications</li>
                <li>We act as a Business Solution Provider under Meta's terms</li>
                <li>Message delivery and storage follow WhatsApp's data handling practices</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Data Sharing and Third Parties</h2>
              <p>We share information with:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Meta (WhatsApp) for message delivery and service provision</li>
                <li>Service providers who assist in our operations</li>
                <li>Legal authorities when required by law</li>
              </ul>
              <p>We do not sell your personal information to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Data Security</h2>
              <p>
                We implement appropriate security measures to protect your information, including:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Encryption in transit and at rest</li>
                <li>Access controls and authentication</li>
                <li>Regular security assessments</li>
                <li>Compliance with industry standards</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Data Retention</h2>
              <p>
                We retain your data only as long as necessary for service provision and legal compliance.
                Message history and contact information are retained according to your account settings
                and applicable legal requirements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing</li>
                <li>Data portability</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. International Transfers</h2>
              <p>
                Your data may be transferred to and processed in countries other than your own.
                We ensure appropriate safeguards are in place for such transfers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Children's Privacy</h2>
              <p>
                Our service is not intended for children under 13. We do not knowingly collect
                personal information from children under 13.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">10. Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. We will notify you of any
                material changes by posting the new policy on our website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">11. Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-muted p-4 rounded-lg">
                <p><strong>Email:</strong> support@wenext.today</p>
                <p><strong>Address:</strong> Sy. No. 78, 3, Hafeezpet Rd, Bikshapathi Nagar, Hafeezpet, Hyderabad, Telangana 500085</p>
              </div>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}